import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { interpolate } from 'helpers/interpolate';
import { CountdownTimer } from 'components/CountdownTimer/CountdownTimer';
import { CmsModules } from 'containers/CmsPage/CmsModules';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { getCountdownTime } from './helpers';
import { ClassDetailsCard } from './ClassDetailsCard';

const messages = defineMessages({
  countdownExpiresTime: {
    id: 'inviteafriend.offer-expires-in',
    defaultMessage: 'Offer expires in',
  },
});

export const ClassAvailableV2 = ({ title, subtitle, referrer, schedule, modules }) => {
  const interpolationVariables = {
    $USER_NAME: referrer.display_name,
    $VENUE_NAME: schedule.venue.name,
  };

  const titleContent = interpolate(title, interpolationVariables);
  const subtitleContent = interpolate(subtitle, interpolationVariables);

  return (
    <div className="ClassAvailableV2">
      <h2 className="ClassAvailableV2__title">{titleContent}</h2>
      <p className="ClassAvailableV2__desktop-subtitle">{subtitleContent}</p>

      <div className="ClassAvailableV2__countdown-wrapper">
        <p className="ClassAvailableV2__countdown">
          <LocalizableMessage message={messages.countdownExpiresTime} />
          &nbsp;
          <CountdownTimer countdownTo={getCountdownTime(schedule.starttime * 1000)} />
        </p>
      </div>

      <div className="ClassAvailableV2__columns">
        <div className="ClassAvailableV2__class-section">
          <ClassDetailsCard schedule={schedule} />
        </div>

        <p className="ClassAvailableV2__mobile-subtitle">{subtitleContent}</p>

        <div className="ClassAvailableV2__product-section">
          <CmsModules modules={modules} />
        </div>
      </div>
    </div>
  );
};

ClassAvailableV2.propTypes = {
  /** CMS property: the main header's title */
  title: PropTypes.string.isRequired,
  /** CMS property: the main header's subtitle. Moved below the fold on mobile */
  subtitle: PropTypes.string.isRequired,
  /**
   * CMS property: The modules used for the "product card section" (the right
   * column on desktop)
   */
  modules: PropTypes.array.isRequired,
  /**
   * The class booking this invite is for.
   * Returned from the /v1/campaign/claim/:referenceHash endpoint: https://development-platform-campaigns.classpass.com/docs/#!/Referral_Campaign_Service/claimCampaignReferral
   */
  schedule: PropTypes.object.isRequired,
  /**
   * The referring user. Only contains the `displayName` to render to the client.
   * Returned from the /v1/campaign/claim/:referenceHash endpoint: https://development-platform-campaigns.classpass.com/docs/#!/Referral_Campaign_Service/claimCampaignReferral
   */
  referrer: PropTypes.object.isRequired,
};
